import { keepPreviousData, useQuery } from "@tanstack/react-query";
import {
  getTerminalInventoryList,
  type SortDirection,
  type TerminalFinancing,
  type TerminalInventoryStatus,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { MS_TIME } from "Utils/TimeUtils";

const TERMINAL_INVENTORY_QUERY_KEY = "TERMINAL_INVENTORY";

export type TerminalInventoryListParams = {
  offset?: number;
  limit?: number;
  sortBy?: string;
  sortDirection?: SortDirection;
  status?: TerminalInventoryStatus;
  financing?: TerminalFinancing;
  serialNumber?: string;
  tid?: string;
  mid?: string;
  hardwareModel?: string;
  hunterName?: string;
  hunterPartyPublicID?: string;
  merchantName?: string;
  facilityName?: string;
};

export const terminalInventoryKeys = {
  all: [TERMINAL_INVENTORY_QUERY_KEY],
  lists: () => [...terminalInventoryKeys.all, "list"],
  byParams: (params: TerminalInventoryListParams) => [
    ...terminalInventoryKeys.lists(),
    params,
  ],
};

export const useTerminalInventoryListQuery = (
  params: TerminalInventoryListParams = {},
) =>
  useQuery({
    queryKey: terminalInventoryKeys.byParams(params),
    queryFn: processResponseWithApiProblemDetails(() =>
      getTerminalInventoryList(
        params.status,
        params.financing,
        params.serialNumber,
        params.tid,
        params.mid,
        params.hardwareModel,
        params.hunterName,
        params.hunterPartyPublicID,
        params.merchantName,
        params.facilityName,
        params.offset,
        params.limit,
        params.sortBy,
        params.sortDirection,
      ),
    ),
    placeholderData: keepPreviousData,
    staleTime: MS_TIME.minute,
  });
